import * as Phaser from "phaser";
import { Scene } from "phaser";
import { EventBus } from "../EventBus";

export class Game extends Scene {
  constructor() {
    super("Game");
  }

  preload() {
    this.load.image("background", "/assets/bg.png");
    this.load.image("red_heli", "/assets/red_heli.png");
    this.load.image("blue_heli", "/assets/blue_heli.png");
    this.load.image("net", "/assets/net.png");
    this.load.image("asteroid", "/assets/asteroid.png");
    this.load.image("logo", "/assets/logo.png");
    this.load.image("arrow_left", "/assets/leftarrow.png");
    this.load.image("arrow_right", "/assets/rightarrow.png");

    this.load.audio("bgm", "/assets/ccr.mp3");
    this.load.audio("catch", "/assets/catch.mp3");
    this.load.audio("loser", "/assets/loser.mp3");
  }

  create() {
    this.resetGame();
    EventBus.emit("current-scene-ready", this);

    this.sfx = {
      catch: this.sound.add("catch"),
      loser: this.sound.add("loser"),
      bgm: this.sound.add("bgm", { loop: true, volume: 0.3 }),
    };

    this.bg = this.add.image(512, 384, "background");
    this.logo = this.add.image(512, 350, "logo");

    this.titleText = this.add
      .text(512, 490, "Get Retcon'd, Blanket", {
        fontFamily: "Comic Sans MS",
        fontSize: 30,
        color: "#ffffff",
        stroke: "#000000",
        strokeThickness: 8,
      })
      .setOrigin(0.5);

    this.creditsText = this.add
      .text(512, 590, "Made with love, by Paul", {
        fontFamily: "Comic Sans MS",
        fontSize: 30,
        color: "#ffffff",
        stroke: "#000000",
        strokeThickness: 8,
      })
      .setOrigin(0.5);
    if (window.innerWidth < 800)  {
      this.inputLeft = false;
      this.inputRight = false;

      this.leftButton = this.add
        .image(100, 500, "arrow_left")
        .setInteractive()
        .setAlpha(0.6)
        .setDepth(10)
        .setScale(1);

      this.rightButton = this.add
        .image(930, 500, "arrow_right")
        .setInteractive()
        .setAlpha(0.6)
        .setDepth(10)
        .setScale(1);

      this.leftButton.on("pointerdown", () => {
        this.inputLeft = true;
      });
      this.leftButton.on("pointerup", () => {
        this.inputLeft = false;
      });
      this.leftButton.on("pointerout", () => {
        this.inputLeft = false;
      });

      this.rightButton.on("pointerdown", () => {
        this.inputRight = true;
      });
      this.rightButton.on("pointerup", () => {
        this.inputRight = false;
      });
      this.rightButton.on("pointerout", () => {
        this.inputRight = false;
      });
    }
  }

  resetGame() {
    this.missedAsteroids = 0;
    this.caughtAsteroids = 0;
    this.maxMisses = 5;
    this.healthBarTargetRatio = 1;
    this.healthBarCurrentRatio = 1;
    this.gameStarted = false;

    this.redHeli?.destroy();
    this.blueHeli?.destroy();
    this.net?.destroy();
    this.scoreText?.destroy();
    this.healthBar?.destroy();

    if (this.asteroids) {
      this.asteroids.clear(true, true);
    }

    this.time?.removeAllEvents();
  }

  startGame() {
    console.log("Phaser: startGame() triggered");

    this.resetGame();
    this.sfx.bgm.play();

    this.bg?.destroy();
    this.logo?.destroy();
    this.titleText?.destroy();
    this.creditsText?.destroy();

    this.add.image(512, 384, "background");

    this.scoreText = this.add.text(20, 50, "Caught: 0", {
      fontSize: "18px",
      color: "#ffffff",
    });

    this.healthBar = this.add.graphics();
    this.healthBarTargetRatio = 1;
    this.healthBarCurrentRatio = 1;

    this.redHeli = this.physics.add.sprite(400, 884, "red_heli").setScale(0.5);
    this.blueHeli = this.physics.add
      .sprite(680, 737, "blue_heli")
      .setScale(0.5);
    this.net = this.physics.add.image(800, 740, "net").setScale(0.07);

    this.redHeli.body.allowGravity = false;
    this.blueHeli.body.allowGravity = false;
    this.net.body.allowGravity = false;

    this.redHeli.body.setImmovable(true);
    this.blueHeli.body.setImmovable(true);
    this.net.body.setImmovable(true);

    this.redHeli.setCollideWorldBounds(true);

    this.cursors = this.input.keyboard.addKeys({
      left: Phaser.Input.Keyboard.KeyCodes.A,
      right: Phaser.Input.Keyboard.KeyCodes.D,
    });

    this.asteroids = this.physics.add.group({
      defaultKey: "asteroid",
      maxSize: 10,
    });

    this.time.addEvent({
      delay: 1000,
      loop: true,
      callback: () => this.spawnAsteroid(),
    });

    this.physics.add.overlap(
      this.asteroids,
      this.redHeli,
      this.catchAsteroid,
      null,
      this
    );
    this.physics.add.overlap(
      this.asteroids,
      this.blueHeli,
      this.catchAsteroid,
      null,
      this
    );

    this.gameStarted = true;
  }

  spawnAsteroid() {
    const x = Phaser.Math.Between(300, 724);
    const asteroid = this.asteroids.get();

    if (!asteroid) return;

    asteroid.setActive(true).setVisible(true).setPosition(x, -50).setScale(0.4);

    if (!asteroid.body) this.physics.world.enable(asteroid);
    asteroid.body.enable = true;

    asteroid.setVelocityY(Phaser.Math.Between(100, 200));
  }

  catchAsteroid(obj1, obj2) {
    this.sfx.catch.play();
    const asteroid = obj1.texture.key === "asteroid" ? obj1 : obj2;
    if (!asteroid.active) return;

    this.caughtAsteroids++;
    this.scoreText.setText(`Caught: ${this.caughtAsteroids}`);
    asteroid.disableBody(true, true);
  }

  update() {
    if (!this.gameStarted) return;

    if (this.cursors.left.isDown || this.inputLeft) {
      this.redHeli.setVelocityX(-200);
    } else if (this.cursors.right.isDown || this.inputRight) {
      this.redHeli.setVelocityX(200);
    } else {
      this.redHeli.setVelocityX(0);
    }

    this.blueHeli.x = Phaser.Math.Linear(
      this.blueHeli.x,
      this.redHeli.x + 140,
      0.1
    );
    this.net.x = (this.redHeli.x + this.blueHeli.x) / 2;

    this.asteroids.getChildren().forEach((asteroid) => {
      if (asteroid.active && asteroid.y > 850) {
        this.missedAsteroids++;
        asteroid.disableBody(true, true);

        this.healthBarTargetRatio = Math.max(
          0,
          (this.maxMisses - this.missedAsteroids) / this.maxMisses
        );

        if (this.missedAsteroids >= this.maxMisses) {
          this.endGame();
        }
      }
    });

    this.updateHealthBar();
  }

  updateHealthBar() {
    const width = 200;
    const height = 20;
    const x = 20;
    const y = 20;

    const speed = 0.02;
    this.healthBarCurrentRatio = Phaser.Math.Linear(
      this.healthBarCurrentRatio,
      this.healthBarTargetRatio,
      speed
    );

    this.healthBar.clear();
    this.healthBar.fillStyle(0x000000);
    this.healthBar.fillRect(x - 2, y - 2, width + 4, height + 4);
    this.healthBar.fillStyle(0xff0000);
    this.healthBar.fillRect(x, y, width * this.healthBarCurrentRatio, height);
  }

  endGame() {
    this.gameStarted = false;
    this.sfx.loser.play();
    this.sfx.bgm.stop();

    const centerX = this.cameras.main.centerX;
    const centerY = this.cameras.main.centerY;

    const message =
      this.caughtAsteroids === 0
        ? "No, Caleb. Just because you didn't try,\ndoesn't mean that a net couldn't catch an asteroid."
        : `Game Over\nYou caught ${this.caughtAsteroids} asteroid${
            this.caughtAsteroids === 1 ? "" : "s"
          }.`;

    this.add
      .text(centerX, centerY, message, {
        fontSize: "24px",
        color: "#ffffff",
        align: "center",
        wordWrap: { width: 500 },
      })
      .setOrigin(0.5);
  }
}
